module.exports = __webpack_public_path__ + "media/images/emblems/Remaufens-coat_of_arms-a544fd000990dee25a950af2f7181565.svg";